var map = {
	"./africanCapitals.json": [
		4567,
		567
	],
	"./animauxScientifiques.json": [
		9595,
		595
	],
	"./bolchevisme.json": [
		5669,
		669
	],
	"./capboulangerieAccronymes.json": [
		1635,
		635
	],
	"./capboulangerieElectrique.json": [
		2918,
		918
	],
	"./capboulangerieOeuf.json": [
		686,
		686
	],
	"./capboulangeriePetrissage.json": [
		6208,
		208
	],
	"./departements.json": [
		7644,
		644
	],
	"./duo.json": [
		9746,
		746
	],
	"./europeanCapitals.json": [
		1882,
		882
	],
	"./frenchlesson.json": [
		1442,
		442
	],
	"./leçonSloveneAvoir.json": [
		4456,
		456
	],
	"./leçonSloveneBases.json": [
		6641,
		641
	],
	"./leçonSloveneDay.json": [
		5701,
		701
	],
	"./leçonSloveneDifficile.json": [
		6650,
		650
	],
	"./leçonSloveneEtre.json": [
		3973,
		973
	],
	"./leçonSloveneExpressions.json": [
		1172,
		172
	],
	"./leçonSloveneFamille.json": [
		9901,
		901
	],
	"./leçonSloveneFeed.json": [
		3485,
		485
	],
	"./leçonSloveneIm.json": [
		2727,
		727
	],
	"./leçonSloveneSentenceFeed.json": [
		5836,
		836
	],
	"./leçonSloveneSentenceJournee.json": [
		7632,
		632
	],
	"./mendeleiev.json": [
		1186,
		186
	],
	"./monnaies.json": [
		7964,
		964
	],
	"./planets.json": [
		9613,
		613
	],
	"./pseudonymes.json": [
		2784,
		784
	],
	"./sloveneAboutMe.json": [
		9729,
		729
	],
	"./sloveneBasics.json": [
		2085,
		85
	],
	"./sloveneBe.json": [
		6607,
		607
	],
	"./sloveneDay.json": [
		3920,
		920
	],
	"./sloveneDifficult.json": [
		6148,
		148
	],
	"./sloveneExpressions.json": [
		2853,
		853
	],
	"./sloveneFamily.json": [
		1626,
		626
	],
	"./sloveneFood.json": [
		7014,
		14
	],
	"./sloveneHave.json": [
		4868,
		868
	],
	"./sloveneSentenceDay.json": [
		2779,
		779
	],
	"./sloveneSentenceFood.json": [
		3663,
		663
	],
	"./test.json": [
		4294,
		294
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3827;
module.exports = webpackAsyncContext;